// extracted by mini-css-extract-plugin
export var Background = "j_p";
export var aniSpin = "j_d";
export var darken = "j_q";